module.exports = __webpack_public_path__ + "img/AGR-A-3-III.bff0fbc9.png";